<template>
  <div class="information">
    <div class="info-top">
      <!-- <div class="mess-con">
        <div class="mess-text">
          <div class="top-mess">{{ InfoDetail.GovernanceCooperation }}</div>
          <div class="top-message">{{ InfoDetail.GovernanceCooperationTxt }}</div>
        </div>
        
      </div> -->
      
    </div>
    <div class="detail">
      <div class="header">{{ $i18n.locale === 'zh' ? obj.title : obj.english_title }}</div>
      <div class="time"><img src="@/assets/img/time.png" alt="">{{ $i18n.locale === 'zh' ? obj.news_date : formatDate(obj.news_date) }}</div>
      <div class="content">{{ $i18n.locale === 'zh' ? obj.content : obj.english_content }}</div>
    </div>
    
  </div>
</template>

<script>
import mock7 from "../../../public/json/信息交流-全球趋势.json";
import mock1 from "../../../public/json/治理合作-政策法规.json";
export default {
  name: 'InformationDetail',
  data() {
    return {
      header: '',
      time: '',
      content: '',
      obj: {},
      tit1:'信息交流',
      tit2:'了解更多国内外人工智能信息'
    }
  },
  computed:{
    InfoDetail(){
      return this.$t('InfoDetail')
    }
  },
  created() {
    const id = this.$route.query.id;
    const type = this.$route.query.type;
    this.tit1 = this.$route.query.tit1;
    this.tit2 = this.$route.query.tit2;
    if (type === 'industry') {
      const list = mock7.RECORDS
      list.forEach((item) => {
        if (String(item.id) === id) {
          this.obj = item
        }
      })
    }
    if (type === 'policy') {
      const list = mock1.RECORDS
      list.forEach((item) => {
        if (String(item.id) === id) {
          this.obj = item
        }
      })
    }
  },
  methods: {
    formatDate(inputDate) {
      const date = new Date(inputDate);
      if (isNaN(date)) {
        console.error('Invalid date format');
        return null;
      }
      const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      return `${month} ${day}, ${year}`;
    }
  }
}
</script>

<style lang="scss" scoped>
.information {
  width: 100%;
  .info-top {
    .mess-con {
      height: 180px;
      max-width: 1200px;
      margin: 0 auto;
      background: url('@/assets/my/head.jpg') no-repeat;
      background-size: 100% 100%;
      .mess-text {
        max-width: 1200px;
        margin: 0 auto;
        text-align: left;
        padding: 0px 0 0 0;
        height: 180px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
    div {
      font-family: Inter;
      color: #fff;
      font-weight: 500;
    }
    .top-mess {
      font-weight: 500;
      font-size: 36px;
      line-height: 36px;
      padding-left: 2vw;
      box-sizing: border-box;
    }
    .top-message {
      font-size: 20px;
      line-height: 27px;
      margin-top: 20px;
      padding-left: 2vw;
      box-sizing: border-box;
    }
  }
}
.detail {
  max-width: 1200px;
  margin: 0 auto;
  padding: 50px 0 130px 0;
  box-sizing: border-box;
  // min-height: 1000px;
  .header {
    min-height: 60px;
    font-family: Inter;
    font-weight: 600;
    font-size: 36px;
    color: #333640;
    line-height: 60px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
  .time {
    max-width: 1200px;
    height: 24px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #61656C;
    line-height: 24px;
    font-style: normal;
    text-transform: none;
    margin: 24px auto 50px;
    padding-bottom: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #E6E8EB;
    img {
      width: 18px;
      height: 18px;
      margin-right: 8px;
    }
  }
  .content {
    text-align: left;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    // padding: 0 2vw;
    box-sizing: border-box;
    color: #61656C;
    line-height: 36px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
@media (max-width: 600px) {
  .info-top {
    .top-mess {
      top: -16% !important;
      left: 15% !important;
      font-size: 20px !important;
    }
    .top-message {
      // top: 40% !important;
      left: 15% !important;
      margin-top: 0px !important;
      font-size: 14px !important;
      text-align: left;
      display: -webkit-box;
      -webkit-line-clamp: 1; //显示最大行数
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .el-form {
    white-space: normal !important;
    text-align: left;
    &>div {
      margin-top: 8px;
    }
  }
  .left-btn > div {
    margin-right: 10px !important;
  }
  .trend-input {
    display: unset !important;
  }
  .bot-bg {
    font-size: 30px !important;
  }
  .en-text {
    font-size: 30px !important;
  }
  .header {
    font-size: 18px !important;
    padding: 0 20px !important;
  }
  .content {
    font-size: 16px !important;
    padding: 0 20px !important;
  }
  .mess-con {
    height: 150px !important;
    padding: 0 2vw;
    box-sizing: border-box;
  }
}
</style>